import { OrganizationsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from 'app/queries/types/TCall';
import type { organizationsKeys } from './organizationsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof organizationsKeys.workspaceMembers>>;

export const createFetchWorkspaceMembersQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId, workspaceId, params }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(
        OrganizationsService.getWorkspaceMembers({
          oid: organizationId,
          workspaceId,
          search: params.search,
          teamsSlugFilter: params.teamsSlugFilter,
        }),
        signal,
      ),
    );
